/* eslint-disable jsx-a11y/anchor-is-valid */
import { NavLink, Redirect, useRouteMatch } from "react-router-dom";
import logo from "../../../img/NavBar/logo.png";
import { ReactComponent as Home } from "../../../img/Section/Home.svg";
import { ReactComponent as Investment } from "../../../img/Section/Investment - Dark.svg";
import { ReactComponent as Staffs } from "../../../img/Section/Staffs.svg";
import { ReactComponent as InvestmentLight } from "../../../img/Section/Investment - Light.svg";
import { ReactComponent as Logout } from "../../../img/Section/Logout.svg";
import { ReactComponent as ArrowRight } from "../../../img/Section/Arrow - Right.svg";
import { useUser } from "../../../utils/Contexts/Context";
import { FaTimes } from "react-icons/fa";
import { createContext, useContext } from "react";
const AsideRefContext = createContext();
function Aside({ AsideRef }) {
    const match = useRouteMatch();
    const {
        user: { mode },
        setUser,
    } = useUser();

    return (
        <div id="aside" ref={AsideRef}>
            <div className="wrapper">
                <div className="aside_tab">
                    <div className="logo">
                        <img src={logo} alt="logo" />
                        <FaTimes
                            size={25}
                            onClick={() => {
                                AsideRef && AsideRef.current.classList.remove("open");
                            }}
                        />
                    </div>
                    <AsideRefContext.Provider value={AsideRef}>
                        <NavItems>
                            <NavItem sufIcon={<Home />} text="dashboard" url="" />
                            {mode === "individual" ? (
                                ((
                                    <NavItem
                                        sufIcon={<Investment />}
                                        text="Pensions"
                                        url="/pensions"
                                    />
                                ),
                                (
                                    <NavItem
                                        sufIcon={<Investment />}
                                        text="Stakings"
                                        url="/stakings"
                                    />
                                ))
                            ) : mode === "company" ? (
                                <NavItem sufIcon={<Staffs />} text="Staffs" url="/staffs" />
                            ) : null}
                            <a href="/" onClick={() => setUser(null)}>
                                <Logout />
                                logout
                            </a>
                        </NavItems>
                    </AsideRefContext.Provider>
                </div>

                <div id="invest">
                    <InvestmentLight />
                    <NavLink
                        to={`${match.url}/stake`}
                        onClick={() => {
                            AsideRef && AsideRef.current.classList.remove("open");
                        }}
                    >
                        <p>Invest Today</p>
                        <ArrowRight />
                    </NavLink>
                </div>
            </div>
        </div>
    );
}

export default Aside;

function NavItems({ children, className }) {
    return (
        <nav className={className}>
            <ul>{children}</ul>
        </nav>
    );
}

function NavItem({ text = "", url = "", sufIcon, className = "" }) {
    const match = useRouteMatch();
    const AsideRef = useContext(AsideRefContext);
    return (
        <NavLink
            to={`${match.url}${url}`}
            activeClassName="active"
            className={className}
            exact={url === ""}
            onClick={() => {
                text === "logout" && LogoutUser();
                AsideRef && AsideRef.current.classList.remove("open");
            }}
        >
            {sufIcon}
            {text}
        </NavLink>
    );
}

async function LogoutUser() {
    const { setUser } = useUser();
    // const res = await Logout_user()
    setUser(null);
    return <Redirect to="" />;
}
